import emojilib from 'emojilib';
import emojiData from 'unicode-emoji-json';

const bySlug:any = {};
for (const e in emojiData) {
  if (emojiData.hasOwnProperty(e)) {
    // @ts-ignore
    const name:string = emojiData[e].slug;
    // @ts-ignore
    bySlug[name] = { ...emojiData[e] };
    bySlug[name].char = e;
    bySlug[name].keywords = [];
    if (emojilib.lib[name]) {
      bySlug[name].keywords = emojilib.lib[name].keywords;
    }
  }
}

export const EmojiBySlug = {
  ...bySlug,
  ...emojilib.lib,
};
